import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;

const DefaultIcon = L.icon({
    iconUrl: require("leaflet/dist/images/marker-icon.png").default,
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png").default,
    shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
    iconSize: [28, 38],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;



// WEBPACK FOOTER //
// ./src/utils/leaflet-icons.js